import { Component, OnInit, Output, Input, EventEmitter, ElementRef, ViewContainerRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { BodyBoxState } from '@fs/enums/body-box-state';
import { SiteNavNewEnum } from '@fs/enums/site-nav-new';
import { CommonMethods } from '@services/common.method';
import { BillingService } from '@fs/services/billing';
import { TabOpenService } from '@services/tab-open.service';
import { AuthService } from '@services/auth.service';
import { CommonService } from '@shared/services/common';
import { BillingDetailModel, PaymentTermModel } from '@fs/models/customer/billing-detail.model';
import { ContactInfoModel } from '@fs/models/customer/contact.info.model';
import { TimeZoneConverter } from '@shared/pipes/timezone-converter';
import { DatePipe } from '@angular/common';

import { ToastrService } from 'ngx-toastr';
import { NotificationsService } from '@shared/services/notification';
import { CustomerEditType } from '@fs/enums/common';
import { Subscription } from 'rxjs';
import { PopupOptions } from "@fs/models/popup-options.model";
import { SpinnerService } from 'src/app/shared/services/spinner.service';
declare var google;
@Component({
  selector: 'fs-lite-customer-edit',
  templateUrl: './cust-edit.component.html',
  styleUrls: ['./cust-edit.component.scss'],
  providers: [TimeZoneConverter, DatePipe]
})
export class CustomerEditComponent implements OnInit {

  //#region Input/Output
  @Output() closeEditCustomerModal = new EventEmitter();
  @Input() detailData: any;
  @Input() tabCounter: number;
  @Input() destroyTab: boolean;
  @Input() customerEditInfo: any;
  //#endregion

  //#region Variable Declarations
  private hasMultipleJobSites: boolean = false;
  private jobSitesData: any;
  public copyJobSiteInfo: any = { firstname: false, lastname: false };
  public isActive: boolean = false;
  public bodyBoxState = BodyBoxState;
  public customerEditForm: FormGroup;
  public showStatusConfirmation: boolean = false;
  public initialData: any;
  public expandedBox: SiteNavNewEnum[] = [SiteNavNewEnum.BillingContact, SiteNavNewEnum.BillingDetails, SiteNavNewEnum.ContactInformation, SiteNavNewEnum.SiteInformation];
  public siteNavNewEnum = SiteNavNewEnum;
  public CustomerEditType: CustomerEditType;
  /** use to show/hide job site sections and also used in submit form to send job site info or not */
  public isShowJobSiteSections: boolean = true;
  public subTabCounter : number;
  public popupOptions: PopupOptions = new PopupOptions();

  private valueChangeSubscription: Subscription;
  //#endregion

  //#region Constructor
  constructor(
    private toastr: NotificationsService,
    private frmbuilder: FormBuilder,
    private billingService: BillingService,
    private commonMethods: CommonMethods,
    private _elementRef: ElementRef,
    private datePipe: DatePipe,
    private tabopen: TabOpenService,
    private httpCommon: CommonService,
    private auth: AuthService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef
  ) {
    this.subTabCounter = this.commonMethods.generateDynamictabCounter();
    this.showspinner.showloader(this.viewContainerRef, this.subTabCounter);
    this.httpCommon.GetIntialData(this.auth.getCompanyId(), "Plan,ServiceAreas,Users,PaymentTerms,TaxGroups,LeadSources,JobSiteClasses").subscribe(
      response => {
        this.initialData = response;
        this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);

      },(error:any)=>{this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
      }
    )
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    /* default binding is done in ngOnChanges() from 'detailData' input property using 'Createform()'
    in this done after searching a customer and then editing it */
  }

  ngOnChanges() {    
    let customerEditType;
    if (this.customerEditInfo != undefined && this.customerEditInfo != null) {
      customerEditType = this.customerEditInfo['customerEditType'];
    }
    if (this.detailData != undefined && this.customerEditForm == null) {
      this.ShowJobSiteSections(customerEditType);
      this.CreateForm(customerEditType);
    }
  }

  ngAfterViewInit() {
    this.commonMethods.scrollBehaviour(this._elementRef.nativeElement);
    this.commonMethods.SetModalHeightWhenScrolled("#modal_container_" + this.tabCounter, $("#mainContainer")[0], this.popupOptions);
  }
  //#endregion

  //#region Methods
  private CreateForm(customerEditType: CustomerEditType = CustomerEditType.BillingAndJobSite) {
    if (this.detailData == null) {
      this.detailData = new BillingDetailModel();
    }
    this.isActive = this.detailData.IsActive;
    let contactModel: ContactInfoModel = new ContactInfoModel();  

    if (customerEditType == CustomerEditType.BillingAndJobSite) {
      this.customerEditForm = this.frmbuilder.group({
        // /* Site Information(1st Section) */
        "siteForm": this.commonMethods.createFSLiteJobSiteForm(this.detailData.JobSites[0]),
        // "siteForm": this.commonMethods.createFSLiteJobSiteForm(this.detailData.JobSites[0]),

        // /* Site Contact Information(2nd Section) */
        "ContactForm": this.commonMethods.createFSLiteJobsiteContactForm(this.detailData.JobSites[0].Contacts[0].Contact),
        // "ContactForm": this.commonMethods.createFSLiteJobsiteContactForm(this.detailData.JobSites[0].Contacts[0]),

        /* Customer Details(3rd Section) */
        "BillingDetailsForm": this.commonMethods.createFSLiteBillingForm(this.detailData),

        /* Customer Contact Information(4th Section) */
        "BillingContactForm": this.commonMethods.createFSLiteBillingContactForm(!CommonMethods.CheckNullOrUndefined(this.detailData.Contacts, true)? this.detailData.Contacts[0].Contact : contactModel)
      });
    }
    else {
      this.customerEditForm = this.frmbuilder.group({
        /* Customer Details(3rd Section) */
        "BillingDetailsForm": this.commonMethods.createFSLiteBillingForm(this.detailData),

        /* Customer Contact Information(4th Section) */
        "BillingContactForm": this.commonMethods.createFSLiteBillingContactForm(!CommonMethods.CheckNullOrUndefined(this.detailData.Contacts, true)? this.detailData.Contacts[0].Contact : contactModel)
      });
    }
    /* used to save values for when submitting form with value checked as 'Same as Job Site' in case of multi job sites */
    // if (customerEditType == CustomerEditType.Billing) {
    //   this.jobSitesData = this.detailData.JobSites;
    // }
    this.hasMultipleJobSites = customerEditType == CustomerEditType.Billing;//(this.customerEditForm.get("siteForm")==undefined);
    var IsJobSiteSameasCustomerDetail = (<FormGroup>this.customerEditForm.get("BillingDetailsForm")).controls["IsDefaultFromJobsite"].value;
    if (this.customerEditForm.get("siteForm") != undefined) {
      if (CommonMethods.CheckNullOrUndefined(this.valueChangeSubscription)) {
        this.valueChangeSubscription = (<FormGroup>this.customerEditForm.get("siteForm")).valueChanges.subscribe(response => {
          if (!CommonMethods.CheckNullOrUndefined(IsJobSiteSameasCustomerDetail) 
            && (<FormGroup>this.customerEditForm.get("BillingDetailsForm")).controls["IsDefaultFromJobsite"].value == true) {
            let excludedControls: string[] = ["comment"];
            this.commonMethods.MapAndFillControl(response, (<FormGroup>this.customerEditForm.get("BillingDetailsForm")), excludedControls);
          }
        });
      }
    }

    if (!CommonMethods.CheckNullOrUndefined(IsJobSiteSameasCustomerDetail) && IsJobSiteSameasCustomerDetail == false && this.hasMultipleJobSites) {
      (<FormGroup>this.customerEditForm.get("BillingDetailsForm")).controls["IsDefaultFromJobsite"].disable();
    }
  }

  public CloseEditModal() {
    this.closeEditCustomerModal.emit(this.customerEditForm.dirty);
  }

  private GetLatitude_Longitude(StreetNo: string, state: string, postalCode: string) {
    return new Promise(function (resolve) {
      var result = [];
      var geocoder = new google.maps.Geocoder();
      var address = StreetNo;
      geocoder.geocode({
        'address': address, 'componentRestrictions': {
          'postalCode': postalCode
        }
      }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var latitude = results[0].geometry.location.lat();
          var longitude = results[0].geometry.location.lng();
          result.push(latitude.toString());
          result.push(longitude.toString());
          resolve(result);
        }
        else {
          result.push('0');
          result.push('0');
          resolve(result);
        }
      });
    });
  }
  public async SaveCustomerDetail() {
    if (this.customerEditForm.valid) {
      this.showspinner.showloader(this.viewContainerRef, this.subTabCounter, 0);
      let submitValues = Object.assign({}, this.customerEditForm.value);
      let submitModel: BillingDetailModel = new BillingDetailModel();
      let paymentTermModel: PaymentTermModel = new PaymentTermModel();
      let jobSiteContactModel: ContactInfoModel = new ContactInfoModel();
      let billingContactModel: ContactInfoModel = new ContactInfoModel();

      submitModel.ID = this.detailData.ID;
      submitModel.IsActive = this.isActive;
      if (submitValues.BillingDetailsForm.IsDefaultFromJobsite && this.isShowJobSiteSections) {
        submitModel.FirstName = submitValues.siteForm.FirstName;
        submitModel.LastName = submitValues.siteForm.LastName;
        submitModel.CompanyName = submitValues.siteForm.CompanyName;
        submitModel.Type = Object.assign({}, { ID: submitValues.siteForm.Type, Code: "", Name: "" });
        submitModel.DisplayName = submitValues.siteForm.DisplayName;
        submitModel.StreetNo = submitValues.siteForm.StreetNo;
        submitModel.Unit = submitValues.siteForm.Unit;
        submitModel.City = submitValues.siteForm.City;
        submitModel.State = submitValues.siteForm.State;
        submitModel.ZipCode = submitValues.siteForm.ZipCode;
        submitModel.IsSameAsJobSite = true;
      }
      else if (submitValues.BillingDetailsForm.IsDefaultFromJobsite && !this.isShowJobSiteSections) {
        submitModel.FirstName = this.detailData.FirstName;
        submitModel.LastName = this.detailData.LastName;
        submitModel.CompanyName = this.detailData.CompanyName;
        submitModel.Type = this.detailData.Type;
        submitModel.DisplayName = this.detailData.DisplayName;
        submitModel.StreetNo = this.detailData.StreetNo;
        submitModel.Unit = this.detailData.Unit;
        submitModel.City = this.detailData.City;
        submitModel.State = this.detailData.State;
        submitModel.ZipCode = this.detailData.ZipCode;
        submitModel.IsSameAsJobSite = true;
      }
      else {
        submitModel.FirstName = submitValues.BillingDetailsForm.FirstName;
        submitModel.LastName = submitValues.BillingDetailsForm.LastName;
        submitModel.CompanyName = submitValues.BillingDetailsForm.CompanyName;
        submitModel.Type = Object.assign({}, { ID: submitValues.BillingDetailsForm.Type, Code: "", Name: "" });
        submitModel.DisplayName = submitValues.BillingDetailsForm.DisplayName;
        submitModel.StreetNo = submitValues.BillingDetailsForm.StreetNo;
        submitModel.Unit = submitValues.BillingDetailsForm.Unit;
        submitModel.City = submitValues.BillingDetailsForm.City;
        submitModel.State = submitValues.BillingDetailsForm.State;
        submitModel.ZipCode = submitValues.BillingDetailsForm.ZipCode;
        submitModel.IsSameAsJobSite = false;
      }

      paymentTermModel.ID = submitValues.BillingDetailsForm.PaymentTerm;
      submitModel.PaymentTerm = paymentTermModel;
      submitModel.CustomerSince = this.datePipe.transform(submitValues.BillingDetailsForm.CustomerSince, "MM/dd/yyyy");

      submitModel.BillingID = "";
      submitModel.Division = null;
      submitModel.Estimator = null;
      submitModel.AccountRep = null;
      submitModel.LeadSource = null;
      submitModel.IsCreditHold = false;
      submitModel.IsNoTransfer = false;
      submitModel.IsPoRequired = false;
      submitModel.LeadSourceComment = "";
      submitModel.LeadSourceEmployee = null;

      submitModel.MappingID = (<FormGroup>this.customerEditForm.controls['BillingDetailsForm']).controls["MappingID"].value;

      /* Billing Contact Validation*/
      if (!this.commonMethods.IsContactModelEmptyOrNull(submitValues.BillingContactForm)) {
        let validationModel = { IsValid: true, Error: "" };
        if (submitValues.BillingContactForm.FirstName == "") {
          validationModel.IsValid = false;
          validationModel.Error = "First Name is required.\r\n";
        }
        if (submitValues.BillingContactForm.PhoneNumber == "") {
          validationModel.IsValid = false;
          validationModel.Error += "Phone Number is required.";
        }
        if (!validationModel.IsValid) {
          this.OnSubmitError(false);
          this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
          this.toastr.showMultiLineError(validationModel.Error, "Error");
          return false;
        }
        billingContactModel.ID = !CommonMethods.CheckNullOrUndefined(this.detailData.Contacts, true)? this.detailData.Contacts[0].ID : "";
        billingContactModel.FirstName = submitValues.BillingContactForm.FirstName;
        billingContactModel.LastName = submitValues.BillingContactForm.LastName;
        billingContactModel.IsPrimary = true;
          billingContactModel.IsDirty = true;
        billingContactModel.PhoneNumbers = [Object.assign({}, { PhoneNumber: submitValues.BillingContactForm.PhoneNumber, Type: { ID: submitValues.BillingContactForm.Type, Code: "", Name: "" }, IsDirty: true, ID: (CommonMethods.CheckNullOrUndefined(this.detailData.Contacts, true) || CommonMethods.CheckNullOrUndefined(this.detailData.Contacts[0].Contact.PhoneNumbers, true)? "" : this.detailData.Contacts[0].Contact.PhoneNumbers[0].ID), Description: submitValues.BillingContactForm.PhoneDescription, IsUsedForSMS: true })];
        if (submitValues.BillingContactForm.EmailAddress != "")
          billingContactModel.Emails = [Object.assign({}, { EmailAddress: submitValues.BillingContactForm.EmailAddress, IsDirty: true, ID: (CommonMethods.CheckNullOrUndefined(this.detailData.Contacts, true) || CommonMethods.CheckNullOrUndefined(this.detailData.Contacts[0].Contact.Emails, true)? "" : this.detailData.Contacts[0].Contact.Emails[0].ID), Description: submitValues.BillingContactForm.EmailDescription, IsUsedForEmail: true })]
        else
          billingContactModel.Emails = [];
        submitModel.Contacts[0] = billingContactModel;
      } else {
        submitModel.Contacts = null;
      }
      submitModel.Comment = submitValues.BillingDetailsForm.Comment;

      /* Pass job site info in case of single job site */
      if (this.isShowJobSiteSections) {
        submitModel.JobSites = [Object.assign({}, submitValues.siteForm)];
        submitModel.JobSites[0].IsActive = this.isActive;
        submitModel.JobSites[0].ID = this.detailData.JobSites[0].ID;
        submitModel.JobSites[0].Type = Object.assign({}, { ID: submitValues.siteForm.Type, Code: "", Name: "" })
        submitModel.JobSites[0].ServiceArea = null;
        submitModel.JobSites[0].TaxGroup = { ID: submitValues.siteForm.TaxGroup }
        submitModel.JobSites[0].SiteClass = null;
        submitModel.JobSites[0].Comment = submitValues.siteForm.Comment;
        submitModel.JobSites[0].MappingID = (<FormGroup>this.customerEditForm.controls['siteForm']).controls["MappingID"].value;

        /* Find latitude and longitude again to cross verify */
        const Coordinates = await this.GetLatitude_Longitude(submitModel.JobSites[0].StreetNo, submitModel.JobSites[0].State, submitModel.JobSites[0].ZipCode);

        submitModel.JobSites[0].Latitude = Coordinates[0];
        submitModel.JobSites[0].Longitude = Coordinates[1];

        jobSiteContactModel.ID = this.detailData.JobSites[0].Contacts[0].ID;
        jobSiteContactModel.FirstName = submitValues.ContactForm.FirstName;
        jobSiteContactModel.LastName = submitValues.ContactForm.LastName;
        jobSiteContactModel.IsPrimary = true;
        jobSiteContactModel.IsDirty = true;
        jobSiteContactModel.PhoneNumbers = [Object.assign({}, { PhoneNumber: submitValues.ContactForm.PhoneNumber, Type: { ID: submitValues.ContactForm.Type, Code: "", Name: "" }, IsDirty: true, ID: this.detailData.JobSites[0].Contacts[0].Contact.PhoneNumbers[0].ID, Description: submitValues.ContactForm.PhoneDescription, IsUsedForSMS: true })];
        if (submitValues.ContactForm.EmailAddress != "")
          jobSiteContactModel.Emails = [Object.assign({}, { EmailAddress: submitValues.ContactForm.EmailAddress, IsDirty: true, ID: (this.detailData.JobSites[0].Contacts[0].Contact.Emails[0] == undefined ? "" : this.detailData.JobSites[0].Contacts[0].Contact.Emails[0].ID), Description: submitValues.ContactForm.EmailDescription, IsUsedForEmail: true })]
        else
          jobSiteContactModel.Emails = [];
        submitModel.JobSites[0].Contacts = [Object.assign({}, jobSiteContactModel)];
      }
      submitModel.ModifyDate = this.detailData.ModifyDate;
      submitModel.BillingID =CommonMethods.GetID();
      this.billingService.saveBillingEditData(this.detailData.ID, submitModel).subscribe(response => {
        this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
      if (this.isShowJobSiteSections)
        this.toastr.success("Customer " + (<FormGroup>this.customerEditForm.controls['BillingDetailsForm']).controls['DisplayName'].value + " updated", "Success!")
      else
        this.toastr.success("Customer updated", "Success!")

      if (this.destroyTab) {
        this.closeEditCustomerModal.emit(response);
        setTimeout(() => {
          this.tabopen.DestroyTab(this.tabCounter)
        }, 100)
      }
      else {
        this.closeEditCustomerModal.emit(response);
      }
      },
        error => {
          this.destroyTab = false;
          this.showspinner.hideLoader(this.viewContainerRef, this.subTabCounter);
          if (error.error != null) {
            let errorMsgUniqueCustDisplayName = "";
            if (this.isShowJobSiteSections) {
              let errorMsgUniqueJobSite = "The customer display name " + (<FormGroup>this.customerEditForm.controls['siteForm']).controls['DisplayName'].value
                + " already exists and must be unique. Please retype in a unique value.";

            errorMsgUniqueCustDisplayName = "The job site display name " + (<FormGroup>this.customerEditForm.controls['BillingDetailsForm']).controls['DisplayName'].value
              + " already exists and must be unique. Please retype in a unique value.";

            errorMsgUniqueCustDisplayName = errorMsgUniqueCustDisplayName.toLowerCase();
            errorMsgUniqueJobSite = errorMsgUniqueJobSite.toLowerCase();

            if (error.error.Message.toLowerCase().indexOf(errorMsgUniqueCustDisplayName) > -1) {
              this.toastr.showMultiLineError("Customer " + (<FormGroup>this.customerEditForm.controls['siteForm']).controls['DisplayName'].value + " failed to update as " + error.error.Message, "Error");
              (<FormGroup>this.customerEditForm.controls['siteForm']).controls['DisplayName'].setErrors({
                "DuplicateName": true
              });
              this.OnSubmitError(true);
            }
          }
          if (error.error.Message.toLowerCase().indexOf(errorMsgUniqueCustDisplayName) > -1) {
            this.toastr.showMultiLineError("Customer " + (<FormGroup>this.customerEditForm.controls['BillingDetailsForm']).controls['DisplayName'].value + " failed to update as " + error.error.Message, "Error");
            (<FormGroup>this.customerEditForm.controls['BillingDetailsForm']).controls['DisplayName'].setErrors({
              "DuplicateName": true
            });
            this.OnSubmitError(true);
          }
          else {
            if (this.isShowJobSiteSections)
              this.toastr.showMultiLineError("Customer " + (<FormGroup>this.customerEditForm.controls['siteForm']).controls['DisplayName'].value + " failed to update as " + error.error.Message, "Error")
          }
        }
      })
    }
    else {
      this.destroyTab = false;
      this.OnSubmitError(true);
      return false;
    }
    return true;
  }

  private OnSubmitError(IsBillingContactFormValid: boolean) {
    if (!CommonMethods.CheckNullOrUndefined(this.customerEditForm.controls['siteForm']) && !this.customerEditForm.controls['siteForm'].valid)
      this.ToggleBoxes([SiteNavNewEnum.SiteInformation])
    else if (!CommonMethods.CheckNullOrUndefined(this.customerEditForm.controls['ContactForm']) && !this.customerEditForm.controls['ContactForm'].valid)
      this.ToggleBoxes([SiteNavNewEnum.ContactInformation])
    else if (!CommonMethods.CheckNullOrUndefined(this.customerEditForm.controls['BillingDetailsForm']) && !this.customerEditForm.controls['BillingDetailsForm'].valid)
      this.ToggleBoxes([SiteNavNewEnum.BillingDetails])
    else if ( !IsBillingContactFormValid)
      this.ToggleBoxes([SiteNavNewEnum.BillingContact])
    this.commonMethods.markFormGroupTouched(this.customerEditForm)
  }

  public ToggleBoxes(data: any) {
    this.expandedBox = [];
    let me = this;
    setTimeout(() => {
      if (data.constructor === Array) {
        me.expandedBox = data;
        setTimeout(() => {
          if ($(me._elementRef.nativeElement).find('input.ng-invalid,select.ng-invalid,input.custom-invalid').first().offset().top < 90)
            $("#mainContainer").scrollTop($("#mainContainer").scrollTop() - 90);
          let ng_elements = $(me._elementRef.nativeElement).find('input.ng-invalid,select.ng-invalid').first();
          if (ng_elements.length > 0) {
            ng_elements.focus();
          } else {
            let cust_elements = $(me._elementRef.nativeElement).find('input.custom-invalid').first();
            if (cust_elements.val() == "")
              cust_elements.focus();
          }
        }, 500);
      }
      else {
        me.expandedBox.push(data);
      }
    }, 200);

  }

  public ShowJobSiteSections(customerEditType: CustomerEditType = CustomerEditType.BillingAndJobSite) {
    this.isShowJobSiteSections = customerEditType == CustomerEditType.BillingAndJobSite ? true : false;
  }

  public ChangeEvent() {
    if (!this.isActive) {
      this.showStatusConfirmation = true;
      $('#chk_active').prop('checked', true);
      event.preventDefault();
    }
  }

  public CancelDeactivateCustomer() {
    $('#chk_active').prop('checked', true);
    this.isActive = true;
    this.showStatusConfirmation = false;
  }

  public DeactivateCustomerConfirmed() {
    $('#chk_active').prop('checked', false);
    this.isActive = false;
    this.showStatusConfirmation = false;
  }

  public CopyTriggered(data) {
    if (data["isCopy"] === true && this.customerEditForm.get("siteForm")!=undefined) {
      const billingForm = (<FormGroup>this.customerEditForm.get("BillingDetailsForm"));
      const siteForm = (<FormGroup>this.customerEditForm.get("siteForm"));
      billingForm.controls["FirstName"].patchValue(siteForm.controls["FirstName"].value);
      billingForm.controls["LastName"].patchValue(siteForm.controls["LastName"].value);
      billingForm.controls["CompanyName"].patchValue(siteForm.controls["CompanyName"].value);
      billingForm.controls["Type"].patchValue(Object.assign({}, { ID: siteForm.controls["Type"].value, Code: "", Name: "" }));
      billingForm.controls["DisplayName"].patchValue(siteForm.controls["DisplayName"].value);
      billingForm.controls["StreetNo"].patchValue(siteForm.controls["StreetNo"].value);
      billingForm.controls["Unit"].patchValue(siteForm.controls["Unit"].value);
      billingForm.controls["City"].patchValue(siteForm.controls["City"].value);
      billingForm.controls["State"].patchValue(siteForm.controls["State"].value);
      billingForm.controls["ZipCode"].patchValue(siteForm.controls["ZipCode"].value);
    }
    else if (this.hasMultipleJobSites) {
      (<FormGroup>this.customerEditForm.get("BillingDetailsForm")).controls["IsDefaultFromJobsite"].disable();
    }
  }
  //#endregion
}
